export const userRoles = {
  ADM: 'ADM',
};

export const allowedRoutes = {
  ADM: ['home', 'users', 'companies', 'contracts', 'invoices'],
};

export const statusSendEmail = {
  SUCCESS: 1,
  ERROR: 2,
  AWAITING_INVOICE: 6,
  AWAITING_NFSE: 7
}

export const detailsIds = Object.freeze({
  PACKAGE_IDS: [7, 20, 22, 32, 72, 73, 74, 97],
  LICENCE: [1],
  CONTACT: [2],
  NUMBER: [3],
  ACTIVE_UNIQUE: [4],
  ACTIVE_CAMPAIGN: [5],
  CONSULTING_MONTH: [6],
  LICENCE_MIN: [8],
  ACTIVE_UNIQUE_MIN: [9],
  ACTIVE_CAMPAIGN_MIN: [10],
  PROTOCOLS: [11],
  AUTONEGOTIATOR: [12],
  AUTONEGOTIATOR_MIN: [13],
  CROSS_SELL: [14, 26, 37],
  NUMBER_EXTRA: [15],
  CONSULTING: [16],
  CUSTOMIZATION: [17],
  SUPORT24X7: [18],
  OTHER: [19, 21],
  CHATBOT_PROTOCOL: [23],
  CHATBOT_SCHEDULE: [24],
  CHATBOT_CPF_UNIQUE: [25],
  ACTIVE_SMS: [28],
  CONTACT_UNIFIED: [29],
  UAM: [30],
  HSM: [31],
  HSM_ACTIVE_UNIQUE: [33],
  HSM_ACTIVE_CAMPAIGN: [34],
  ATTENDANCE_PROTOCOL: [35],
  ACTIVE_CAMPAIGN_SMS: [36],
  SETUP_ACQUISITION: [41, 42, 43],
  ENTERPRISE_NUMBER: [44, 68],
  RECURRENCE: [48, 49, 50],
  SESSION_SERVICE: [51, 63],
  SESSION_MARKETING: [52, 64],
  SESSION_UTILITY: [53, 65],
  SESSION_AUTHENTICATION: [54, 66],
  MESSAGE: [55],
  ACTIVE_UNIFIED_UNIQUE_CAMPAIGN: [56],
  SESSION_UNIFIED: [61, 67],
  REPORT: [69],
  ADDITIONAL: [75, 76, 77, 101, 102, 103],
  PROJECT_ACQUISITION: [78, 79, 80],
  SETUP_BASE: [81, 82, 83, 100],
  PROJECT_BASE: [84, 85, 86],
  CANCELLATION: [27, 87, 88, 89],
  CONTRACTUAL_FINES: [90, 91, 92]
})

export const products = Object.freeze({
  WHATSAPP_ENTERPRISE: 8,
  YAPT: 9
})

export default {
  userRoles,
  allowedRoutes,
  statusSendEmail,
  detailsIds,
  products
};
